import React from "react";
import TaskposterUtil from "./taskposter_util";
import {MsgBox} from "../../cmpts/msg_box";
import Modal from "../../cmpts/modal";

let MODIFY_FORM_LINK = {
    target: null,
    doit: false
};

let des = {
    marginTop: '10px'
}

export class ModifyFormLink {

    static initFormLinkEvent() {
        $(".FORMLINK").unbind('click');
        $(".FORMLINK").click(function (e) {
            e.preventDefault();
            MODIFY_FORM_LINK = {
                doit: true,
                target: $(this)
            };
            $("#insertFormLink .mxd-modal-header h4").html('修改一阶任务表单链接');
            Modal.show("#insertFormLink")
            var text = $(this).html();
            $("#FormLinkText").val(text);
        })
    }
}

export class InsertFormLinkModal extends React.Component {
    constructor(props) {
        super(props);
        this.init = this.init.bind(this);
        this.submit = this.submit.bind(this);
    }

    init() {
        $("#FormLinkText").val('');
        Modal.hide("#insertFormLink")
        MODIFY_FORM_LINK = {
            doit: false,
            target: null
        };
        $("#insertFormLink .mxd-modal-header h4").html('插入一阶任务表单链接')
    }

    submit() {
        var FormLinkText = $("#FormLinkText").val();
        if (FormLinkText.length == 0) {
            MsgBox.showWarningMsg_2s("请输入一阶任务表单链接文本");
            $("#FormLinkText").focus();
            return;
        }
        if (MODIFY_FORM_LINK.doit) {
            MODIFY_FORM_LINK.target.html(FormLinkText);
        } else {
            var targetAreaId = $("#insertFormLink").attr('targetArea');
            var FORM_LINK_ITEM = '<span class="tpmsgend"></span><a id="FORMLINK" class="cursor-pointer FORMLINK" contenteditable="false">' + FormLinkText + '</a><span class="tpmsgend"></span>';
            var span = document.createElement("a");
            span.innerHTML = FormLinkText;
            span.setAttribute('contenteditable', 'false');
            span.setAttribute('id', 'FORMLINK');
            span.setAttribute('class', 'cursor-pointer FORMLINK');
            span.setAttribute('target', '_blank');
            TaskposterUtil.insertTextItem_(targetAreaId, FORM_LINK_ITEM, span);
            ModifyFormLink.initFormLinkEvent();
        }
        this.init();
    }

    render() {
        return (
            <div className="mxd-modal" id="insertFormLink">
                <div className="mxd-modal-header">
                    <h4>插入一阶任务表单链接</h4>
                    <span className="close" onClick={this.init}></span>
                </div>
                <div className="mxd-modal-body mxd-form">
                    <div className="mxd-form-item">
                        <div className="mxd-form-title">
                            <label>一阶任务表单链接文本</label>
                        </div>
                        <input id="FormLinkText" ref="FormLinkText" type="text"
                               autoComplete="off"
                               className="mxd-input form-control"/>
                    </div>
                    <p style={des} className="text-gray">
                        亲，这里只需要输入表单链接文本即可，表单链接在发送消息时系统会自动为你添加上，请您放心。
                    </p>
                </div>
                <div className="mxd-modal-footer-space"></div>
                <div className="mxd-modal-footer">
                    <button type="button" className="mxd-btn mxd-btn-primary" onClick={this.submit}>确定
                    </button>
                    <button type="button" className="mxd-btn mxd-btn-cancel" onClick={this.init}>取消</button>
                </div>
            </div>
        )
    }
}